__turbopack_context__.v({
  "form": "UwsPUG_form",
  "onboard": "UwsPUG_onboard",
});
